import React, { useEffect, useRef, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import countries from '../../arrays/countries.json'
import languages from '../../arrays/languages.json'
// import genres from '../../arrays/genres.json'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import {  storage } from '../../firebase'
import { getDownloadURL, uploadBytes, ref as sRef } from 'firebase/storage'
import emails from '../../arrays/emails.json'
import axios from 'axios'
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css'; // Import the CSS for styling
import { enGB } from 'date-fns/locale';
import { parse, isValid } from 'date-fns';
import { getRelease, updateRelease } from '../../api/releases';
import { getGenres } from '../../api/genres';
import { getPlatforms } from '../../api/platforms';
import { getAllUsers, getUser } from '../../api/user';
import { useQuery, useQueries } from '@tanstack/react-query';
import { Shimmer } from 'react-shimmer';
import { Alert, Box, CircularProgress, Snackbar } from '@mui/material';
import { getAllArtists, getArtists } from '../../api/artists';
import { getAllLabels } from '../../api/labels';

export  function snakeToCamel(obj) {
    const newObj = {};
    for (const key in obj) {
      const camelKey = key.replace(/_([a-z])/g, (match, char) => char.toUpperCase());
      newObj[camelKey] = obj[key];
    }
    return newObj;
  }

// Shimmer loading component
const ShimmerLoading = () => {
  return (
    <div className="container mt-4">
      <div className="row">
        <div className="col-12 mb-4">
          <Shimmer width="100%" height={50} />
        </div>
        <div className="col-md-6 mb-3">
          <Shimmer width="100%" height={40} />
        </div>
        <div className="col-md-6 mb-3">
          <Shimmer width="100%" height={40} />
        </div>
        <div className="col-12 mb-3">
          <Shimmer width="100%" height={100} />
        </div>
        <div className="col-md-4 mb-3">
          <Shimmer width="100%" height={40} />
        </div>
        <div className="col-md-4 mb-3">
          <Shimmer width="100%" height={40} />
        </div>
        <div className="col-md-4 mb-3">
          <Shimmer width="100%" height={40} />
        </div>
        <div className="col-12 mb-3">
          <Shimmer width="100%" height={200} />
        </div>
      </div>
    </div>
  );
};

// Error component
const ErrorDisplay = ({ error, onRetry }) => {
  return (
    <div className="container mt-4">
      <Alert severity="error" variant="filled" sx={{ mb: 2 }}>
        {error?.message || 'An error occurred while loading data'}
      </Alert>
      {onRetry && (
        <button className="btn btn-primary" onClick={onRetry}>
          Retry
        </button>
      )}
    </div>
  );
};

const AdminEditRelease = () => {
    const labels = [
        "Universal Music Group",
        "Sony Music Entertainment",
        "Warner Music Group",
        "EMI Music",
        "Capitol Records",
        "Interscope Records",
        "Columbia Records",
        "Atlantic Records",
        "RCA Records",
        "Def Jam Recordings",
        "Island Records",
        "Republic Records",
        "Sub Pop Records",
        "Motown Records",
        "Merge Records",
        "XL Recordings",
        "Domino Recording Company",
        "Nonesuch Records",
        "Jazzland Recordings",
        "Rough Trade Records"
    ]

    // Error handling states
    const [openErrorSnackbar, setOpenErrorSnackbar] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [isLoading, setIsLoading] = useState(true);

    const handleCloseErrorSnackbar = () => {
        setOpenErrorSnackbar(false);
    };

    const [tab, setTab] = useState(1)

    const [activeRadio, setActiveRadio] = useState(1);
    const [activeRadio1, setActiveRadio1] = useState(1);

    const [tracks, setTracks] = useState([])
    const [artists1, setArtists1] = useState([])
    const [artists2, setArtists2] = useState([])
    const [artistRole, setArtistRole] = useState('Featuring')
    const [artistName, setArtistName] = useState({name: 'Name', id: ''})

    const [isrcDisabled, setIsrcDisabled] = useState(false)
    const [upcDisabled, setUpcDisabled] = useState(false)

    const [genresList, setGenresList] = useState([])
    const [primaryGenresList, setPrimaryGenresList] = useState([])
    const [secondaryGenresList, setSecondaryGenresList] = useState([])
    const [genre, setGenre] = useState('')
    const [primaryGenre, setPrimaryGenre] = useState('')
    const [secondaryGenre, setSecondaryGenre] = useState('')

    const [editTitle, setEditTitle] = useState('')
    const [editId, setEditId] = useState('')

    const filterGenres = (e) => {
        setGenre(e.target.value)
        setGenresList(genres.filter(item => item.toLowerCase().includes(e.target.value.toLowerCase())))
    }
    const filterPrimaryGenres = (e) => {
        setPrimaryGenre(e.target.value)
        setPrimaryGenresList(genres.filter(item => item.toLowerCase().includes(e.target.value.toLowerCase())))
    }
    const filterSecondaryGenres = (e) => {
        setSecondaryGenre(e.target.value)
        setSecondaryGenresList(genres.filter(item => item.toLowerCase().includes(e.target.value.toLowerCase())))
    }

    const [labelsList, setLabelsList] = useState(labels)
    const [label, setLabel] = useState('')

    const filterLabels = (e) => {
        setLabel(e.target.value)
        setLabelsList(labels.filter(item => item.toLowerCase().includes(e.target.value.toLowerCase())))
    }

    const removeArtist1 = (index) => {
        const updatedData = [...artists1];
        updatedData.splice(index, 1);
        setArtists1(updatedData);
    };
    const removeArtist2 = (index) => {
        const updatedData = [...artists2];
        updatedData.splice(index, 1);
        setArtists2(updatedData);
    };



    const formatDuration = (durationInSeconds) => {
        const minutes = Math.floor(durationInSeconds / 60);
        const seconds = Math.floor(durationInSeconds % 60);
        const formattedDuration = `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
        return formattedDuration;
    }



    const jsmediatags = window.jsmediatags

    const uploadTrack = async (file) => {
        const storageRef = sRef(storage, `tracks/${file.name}`);
      
        try {
          await uploadBytes(storageRef, file);
          const downloadURL = await getDownloadURL(storageRef);
          return downloadURL

        } catch (error) {
          console.error("Error uploading file:", error);
        }
    } 

    const [loader, setLoader] = useState(false)

    const readFile = (event) => {
        setLoader(true);
        const songs = event.target.files;
        const promises = [];
      
        for (let i = 0; i < songs.length; i++) {
          const song = songs[i];
          const promise = uploadTrack(song).then((result) => {
            return new Promise((resolve) => {
              setTimeout(() => {
                var uniqueId = Math.random().toString(36).substr(2, 9);
                const audio = new Audio(URL.createObjectURL(song));
      
                audio.onloadedmetadata = () => {
                  jsmediatags.read(song, {
                    onSuccess: function (tag) {
                      setTracks((oldTracks) => [
                        ...oldTracks,
                        {
                          title: tag.tags.title || song.name,
                          filename: tag.tags.title || song.name,
                          id: uniqueId,
                          artists: artists2,
                          genre: genre,
                          clipStart: clipStart,
                          isrc: isrc,
                          copyright: copyright,
                          trackLanguage: trackLanguage,
                          explicit: explicit,
                          duration: formatDuration(audio.duration),
                          file: result,
                          lyrics: lyrics
                        },
                      ]);
                      resolve(); // Resolve the inner promise after handling the track
                    },
                    onError: function (error) {
                      console.log(error);
                      setTracks((oldTracks) => [
                        ...oldTracks,
                        {
                          title: song.name,
                          filename: song.name,
                          id: uniqueId,
                          artists: [],
                          genre: genre,
                          clipStart: clipStart,
                          isrc: isrc,
                          copyright: copyright,
                          trackLanguage: trackLanguage,
                          explicit: explicit,
                          duration: formatDuration(audio.duration),
                          file: result,
                          lyrics: lyrics
                        },
                      ]);
                      resolve(); // Resolve the inner promise after handling the track
                    },
                  });
                };
              }, 500);
            });
          });
      
          promises.push(promise);
        }
      
        // Use Promise.all to wait for all promises to settle
        Promise.all(promises)
          .then(() => {
            // This block will be executed after all promises are settled
            setLoader(false);
          })
          .catch((error) => {
            console.error('Error processing tracks:', error);
            setLoader(false); // Ensure loader is set to false in case of an error
          });
    };

    const removeTrack = (index) => {
        const updatedData = [...tracks];
        updatedData.splice(index, 1);
        setTracks(updatedData);
    };


    const onDragEnd = (result) => {
        if (!result.destination) {
            return;
        }
    
        const reorderedItems = Array.from(tracks);
        const [reorderedItem] = reorderedItems.splice(result.source.index, 1);
        reorderedItems.splice(result.destination.index, 0, reorderedItem);
    
        setTracks(reorderedItems);
    };
    

    

    const [checkedCountries, setCheckedCountries] = useState(['Worldwide']);

    const handleCheckCountry = (country, e) => {
        if (e.target.checked) {
          setCheckedCountries([...checkedCountries, country]);
        } else {
          setCheckedCountries(checkedCountries.filter((c) => c !== country));
        }
    };



    const updateTrack = () => {
        const updatedTracks = tracks.map(item => {
          if (item.id === editId) {
            
            return { 
                ...item,
                title: editTitle,
                artists: artists2,
                genre: genre,
                clipStart: clipStart,
                isrc: isrc,
                copyright: copyright,
                trackLanguage: trackLanguage,
                explicit: explicit,
                lyrics: lyrics
            };
          }
          
          return item;
        });
    
        setTracks(updatedTracks);
    };




    //////////////////////////////////////////////
    ////////////////// BACKEND ///////////////////
    //////////////////////////////////////////////

    const { index, uid } = useParams()
    const [platforms, setPlatforms] = useState([])
    const [artists, setArtists] = useState([])

    const [title, setTitle] = useState('')
    const [upc, setUpc] = useState('')
    const [originalDate, setOriginalDate] = useState('')
    const [digitalDate, setDigitalDate] = useState('')
    const [years, setYears] = useState([])
    const [copyrightYear, setCopyrightYear] = useState('')
    const [copyrightLine, setCopyrightLine] = useState('')
    const [publishingYear, setPublishingYear] = useState('')
    const [publishingLine, setPublishingLine] = useState('')
    const [clipStart, setClipStart] = useState('')
    const [isrc, setIsrc] = useState('')
    const [copyright, setCopyright] = useState('')
    const [trackLanguage, setTrackLanguage] = useState('Instrumental')
    const [role, setRole] = useState('')
    const [writerName, setWriterName] = useState('')
    const [share, setShare] = useState('')
    const [distribution, setDistribution] = useState('Streaming Only')
    const [explicit, setExplicit] = useState('Yes')
    const [status, setStatus] = useState('')
    const [statusNotes, setStatusNotes] = useState('')
    const [username, setUsername] = useState('')
    const [userEmail, setUserEmail] = useState('')
    const [initialStatus, setInitialStatus] = useState('')
    const [platformLink, setPlatformLink] = useState('')
    const [platformIndex, setPlatformIndex] = useState('')
    const [statusAll, setStatusAll] = useState('Distributed')
    const [checkedAll, setCheckedAll] = useState(false)
    const [customID, setCustomID] = useState('')
    const [upcs, setUpcs] = useState([])
    const [counter, setCounter] = useState('')
    const [prefix, setPrefix] = useState('')
    const [genres, setGenres] = useState([])
    const [lyrics, setLyrics] = useState('')
    const [wasLive, setWasLive] = useState()

    const successBtn = useRef()

    const { data: releaseInfo, isLoading: isReleaseLoading, error: releaseError, refetch: refetchRelease } = useQuery({
        queryKey: ['release', index],
        queryFn: () => getRelease(index),
        retry: 1,
        onError: (error) => {
            setErrorMessage(`Error loading release: ${error.message}`);
            setOpenErrorSnackbar(true);
        }
    })
    const {data: artistsInfo, isLoading: isUsersLoading, error: usersError, refetch: refetchUsers } = useQuery({
        queryKey: ['artists'],
        queryFn: () => getAllArtists(),
        retry: 1,
        select: (data) => data.artists,
        onError: (error) => {
            setErrorMessage(`Error loading user info: ${error.message}`);
            setOpenErrorSnackbar(true);
        }
    })
    const {data: genresInfo, isLoading: isGenresLoading, error: genresError, refetch: refetchGenres } = useQuery({
        queryKey: ['genres'],
        queryFn: () => getGenres(),
        retry: 1,
        onError: (error) => {
            setErrorMessage(`Error loading genres: ${error.message}`);
            setOpenErrorSnackbar(true);
        }
    })
    const {data: platformsInfo, isLoading: isPlatformsLoading, error: platformsError, refetch: refetchPlatforms } = useQuery({
        queryKey: ['platforms'],
        queryFn: () => getPlatforms(),
        retry: 1,
        onError: (error) => {
            setErrorMessage(`Error loading platforms: ${error.message}`);
            setOpenErrorSnackbar(true);

        }
    })
    const {data: labelsInfo, isLoading: isLabelsLoading, error: labelsError} = useQuery({
        queryKey: ["labels"],
        queryFn: () => getAllLabels(),
        select: (data) => data.labels,
    })
    useEffect(()=> {
        if(releaseInfo && platformsInfo){
            initialValues(releaseInfo)
            let mappedInfo = releaseInfo.distributions.map(platform => {
                return {
                    ...platform,
                    checked: platform.check || false,
                    platformId: platform.platform_id || platform.platformId,
                    logo: platform.platform.logo
                }
            })
            const not_exist_platforms = platformsInfo.platforms.filter(platform => !mappedInfo.find(item => item.platform_id === platform.platform_id))
            
            mappedInfo.push(...not_exist_platforms.map(platform => ({
                ...platform,
                checked: false,
                platformId: platform.platform_id || platform.platformId,
                status: 'Processing',
                link: '',
                country: 'Worldwide'
            })))
            console.log(mappedInfo, 'not_exist_platforms')
           
            setPlatforms(mappedInfo)
        }
        if(artistsInfo && labelsInfo && releaseInfo){
            const user_id = releaseInfo.user_profile_id;
            const artists = artistsInfo.filter(artist => artist.user_profile_id === user_id)
            console.log(artistsInfo, 'artistsInfo')
            console.log(labelsInfo, 'labelsInfo')
            setArtists(artists)
            setLabelsList(labelsInfo)
        }
        if(genresInfo){
            const genresArray = genresInfo.genres.map(genre => genre.name);
            setGenres(genresArray);
            setGenresList(genresArray);
            setPrimaryGenresList(genresArray);
            setSecondaryGenresList(genresArray);
        }
       
        
        // Handle errors
        if (releaseError || usersError || genresError || platformsError) {
            const errorMessages = [];
            if (releaseError) errorMessages.push(`Release: ${releaseError.message}`);
            if (usersError) errorMessages.push(`User info: ${usersError.message}`);
            if (genresError) errorMessages.push(`Genres: ${genresError.message}`);
            if (platformsError) errorMessages.push(`Platforms: ${platformsError.message}`);
            
            setErrorMessage(`Errors occurred: ${errorMessages.join(', ')}`);
            setOpenErrorSnackbar(true);
        }

        // Update loading state
        if (!isReleaseLoading && !isUsersLoading && !isGenresLoading && !isPlatformsLoading) {
            setIsLoading(false);
        }
        
        fetchYear();

    }, [platformsInfo, artistsInfo,labelsInfo, genresInfo, releaseInfo, releaseError, usersError, genresError, platformsError, 
        isReleaseLoading, isUsersLoading, isGenresLoading, isPlatformsLoading]);
    //////////// GET USER'S RELEASES ////////////
    
    

    const fetchYear = async () => {
        try {
            // const response = await fetch("https://worldtimeapi.org/api/ip");
            // if (!response.ok) {
            //     throw new Error("Failed to fetch the current year");
            // }
            // const data = await response.json();
            const year = new Date().getFullYear();
            setCopyrightYear(year);
            setPublishingYear(year);

            const yearsArray = []

            for (let currentYear = year; currentYear >= 1990; currentYear--) {
                yearsArray.push(currentYear);
            }

            setYears(yearsArray)
        } catch (err) {
          setError(err.message);
        }
    };

    

    const handleSort = (platformsArr) => {
        const sortedData = [...platformsArr].sort((a, b) => {
            return a.title.localeCompare(b.title);
        })

        return sortedData
    };

    const selectedPlatforms = platforms.filter(item => item.selected === true)


    function formatInitialDate(dateString) {
        let date;
        
        // Try parsing the date in the format 'yyyy/MM/dd'
        date = parse(dateString, 'yyyy/MM/dd', new Date());
        if (isValid(date)) {
            return date;
        }
    
        // If the date is invalid, return the current date
        return new Date();
    }
    
    const initialValues = (item) => {
        const artistsM = item?.release_artist?.map(artistI => snakeToCamel({
            role: artistI?.role || '',
            name: artistI?.artist.name || '',
            artistId: artistI.artist_id || artistI.id,
        }))
        console.log(artistsM, 'artistm')
        const tracksM = item?.tracks?.map(trackI => snakeToCamel(trackI))
        if(item.countries && !item.countries.includes('Worldwide')){
            setCheckedCountries(item.countries)
            setActiveRadio(2)
        }
        if(item.countries && item.countries.includes('Worldwide')){
            setCheckedCountries(item.countries)
            setActiveRadio(1)
        }
        console.log(item.countries);
            setCustomID(item.customID || '')
            setTitle(item.title || '')
            setArtists1(artistsM || [])
            setUpc(item.upc || '')
            setPrimaryGenre(item.primary_genre || '')
            setSecondaryGenre(item.secondary_genre || '')
            setLabel(item.label || '')
            setOriginalDate(item.original_date ? new Date(item.original_date) : '')
            setDigitalDate(item.digital_date ? new Date(item.digital_date) : '')
            setCopyrightYear(item.copyright_year || '')
            setCopyrightLine(item.copyright_line || '')
            setPublishingYear(item.publishing_year || '')
            setPublishingLine(item.publishing_line || '')
            setCheckedCountries(item.countries)
            setTracks(tracksM || [])
            setWasLive(item.was_live);
            setUpcDisabled(item.auto_upc === true ? true : false)
            // setShare(item.share)
            // setWriterName(item.writerName)
            setDistribution(item.distribution || 'All')
            setImgSrc(item.artwork || '')
            setStatus(item.status || '')
            setInitialStatus(item.status || '')
            setStatusNotes(item.status_notes || '')
            item.artwork && setImgPreview(true)
            item.artwork && setUploadLabel('Replace file')
      
    }


    const updatePlatforms = () => {
        let newPlatforms = []
        let count = 0
        platforms.forEach(platform => {
            if (platform.checked === true) {
                newPlatforms.push({
                    id: platform.id,
                    status: platform.status,
                    checked: true,
                    link: platform.link,
                    country: platform.country
                })
            }
            count++
        })
        if (count === platforms.length) {
            return newPlatforms
        }
    }

    const statusClasses = {
        'Never Distributed': 's-orange',
        'Distributed': 's-green',
        'Processing': 's-blue',
        'Taken Down': 's-red n-right',
        'Error': 's-red n-right'
    }

    const handleCheck = (index) => {
        let newPlatforms = [...platforms]
        if (newPlatforms[index].selected === true) {
            newPlatforms[index].selected = false
            setPlatforms(newPlatforms)
        } else {
            newPlatforms[index].selected = true
            setPlatforms(newPlatforms)
        }
    }

    const checkAll = () => {
        setCheckedAll(!checkedAll)
        let newPlatforms = [...platforms]
        for (let i = 0; i < newPlatforms.length; i++) {
            const element = newPlatforms[i];
            element.selected = !checkedAll
        }
        setPlatforms(newPlatforms)
    }

    const updateAllStatus = () => {
        let newPlatforms = [...platforms]
        for (let i = 0; i < newPlatforms.length; i++) {
            const element = newPlatforms[i];
            if (element.selected === true) {
                element.status = statusAll
                setPlatforms(newPlatforms)
            }
        }
    }

    const updateStatus = () => {
        let newPlatforms = [...platforms]
        newPlatforms[platformIndex].link = platformLink
        setPlatforms(newPlatforms)
    }

    const takeDown = (id) => {
        let newPlatforms = [...platforms]
        newPlatforms[id].status = 'Taken Down'
        setPlatforms(newPlatforms)
    }

    const distribute = (id) => {
        let newPlatforms = [...platforms]
        newPlatforms[id].status = 'Distributed'
        setPlatforms(newPlatforms)
    }

    const releaseStatus = () => {
        const errorExist = platforms.find(item => item.status === 'Error')
        const processingExist = platforms.find(item => item.status === 'Processing')
        const liveExist = platforms.find(item => item.status === 'Distributed')
        const takeDownExist = platforms.every(item => item.status === 'Taken Down')
        if (errorExist) {
            return 'Error'
        } else if (processingExist) {
            return 'Processing'
        } else if (liveExist) {
            return 'Distributed'
        } else if (takeDownExist) {
            return 'Takedown'
        }
    }

    const autoISRC = () => {
        const updatedTracks = []
        let mappedTrack = tracks.map(track => ({...track, autoISRC: track.autoIsrc
            || false}))
        for (let i = 0; i < mappedTrack.length; i++) {
            const track = mappedTrack[i];
            if (track.autoISRC === true && status !== 'Distributed' && releaseStatus() === 'Distributed') {
                updatedTracks.push({ 
                    ...track,
                    autoISRC: true
                })
            } else {
                updatedTracks.push(track)
            }
        }

        return {updatedTracks}

    }

    const formatDate = (date) => {
        const day = String(date.getDate()).padStart(2, '0'); // Get day and pad with leading zero
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Get month (0-indexed, hence +1)
        const year = date.getFullYear(); // Get year
      
        return `${year}/${month}/${day}`; // Construct "dd/mm/yyyy" format
    };

    const [error, setError] = useState('')

    const handleError = (errorMsg) => {
        setError(errorMsg)
        setTimeout(() => {
            setError('')
        }, 3000);
    }
    const hasArtistsForAllRoles = (artists, roles) => {
        const artistRoles = artists.map(artist => artist.role);

        let missingRoles = {}

        if (artistRoles.includes("Composer & Lyricist")) {
            roles = roles.filter(role => role !== "Composer" && role !== "Lyricist");
        }

        roles.forEach(role => {
            const foundRole = artistRoles.find(item => item === role)
            if (!foundRole) missingRoles[role] = true
        })

        // return roles.every(role => artistRoles.includes(role))
        return missingRoles
    };
    const rolesToCheck = ['Composer', 'Lyricist', 'Primary Artist'];
    const handleAddRelease = async () => {
        // Set loader to true at the beginning to show loading and disable button
     

        const updatedTracks = autoISRC()
        const isDistribute = platforms.find(item => item.status === 'Distributed') ? true : false
        const isTakenDown = platforms.every(item => item.status === 'Taken Down') ? true : false

        const release = {
            userProfileId: uid,
            customID: '',
            title: title,
            wasLive: wasLive,
            artists: artists1,
            upc: upc,
            primaryGenre: primaryGenre,
            secondaryGenre: secondaryGenre,
            label: label,
            originalDate: originalDate.toISOString(),
            digitalDate: digitalDate.toISOString(),
            copyrightYear: copyrightYear,
            copyrightLine: copyrightLine,
            publishingYear: publishingYear,
            publishingLine: publishingLine,
            countries: checkedCountries,
            tracks: updatedTracks.updatedTracks,
            // share: share,
            // writerName: writerName,
            distribution: distribution,
            status: isDistribute ? 'Distributed' : isTakenDown ? 'Taken Down' : 'Processing',
            artwork: imgSrc,
            platforms: platforms.map(platform => ({...platform, check: platform.check || platform.selected})),
            autoUPC: upcDisabled,
            distributions: platforms.map(platform => ({...platform, check: platform.check || platform.selected}))
        }
        
        const hasAllRolesInReleaseArtists = hasArtistsForAllRoles(release.artists, rolesToCheck);
        const hasAllRolesInTracks = release.tracks.every(track => hasArtistsForAllRoles(track.artists || [], rolesToCheck));

        let missingArtistsMessage = []
        if (Object.keys(hasAllRolesInReleaseArtists).length !== 0) {
            const missingReleaseArtists = Object.keys(hasAllRolesInReleaseArtists).join(', ')
            missingArtistsMessage.push(`The release is missing the <i>${missingReleaseArtists}</i>`)
        }
        release.tracks.forEach((track, index) => {
            const missingArtists = hasArtistsForAllRoles(track.artists || [], rolesToCheck)
            if (Object.keys(missingArtists).length !== 0) {
                const missingTrackArtists = Object.keys(missingArtists).join(', ')
                missingArtistsMessage.push(`The track ${index + 1} is missing the <i>${missingTrackArtists}</i>`)
            }
        })
        if (missingArtistsMessage.length === 0) {
            const missingISRCs = tracks.find(item => item.isrc === '' && item.autoISRC === false)
            const missingTrackTitle = tracks.find(item => item.title.trim() === '')
            const missingTrackGenre = tracks.find(item => item.genre === '')
            if (imgPreview === false) {
                handleError('Artwork missing')
                setLoader(false); // Reset loader if validation fails
            } else if (title.trim() === '') {
                handleError('Title missing')
                setLoader(false);
            } else if (tracks.length === 0) {
                handleError('Tracks missing')
                setLoader(false);
            } else if (primaryGenre === '') {
                handleError('Missing primary genre')
                setLoader(false);
            } else if (secondaryGenre === '') {
                handleError('Missing secondary genre')
                setLoader(false);
            } else if (upc === '' && upcDisabled === false) {
                handleError('Missing UPC')
                setLoader(false);
            } else if (missingISRCs) {
                handleError('Missing ISRCs')
                setLoader(false);
            } else if (missingTrackTitle) {
                handleError('Missing track\'s title')
                setLoader(false);
            } else if (missingTrackGenre) {
                handleError('Missing track\'s genre')
                setLoader(false);
            } else {

                const primaryArtists = release.artists.filter(artist => artist.role === 'Primary Artist')
                try {
                    setLoader(true);
                    const response = await updateRelease(index, {
                        ...release,
                    })
                    setLoader(false);
                    successBtn.current.click();
                } catch (error) {
                    handleError('Failed to create release: ' + error.message);
                } finally {
                    setLoader(false); // Always reset loader after API call
                }
               

            }
        } else {
            const artistsErrorMessage = missingArtistsMessage.join('<br />')
            handleError(artistsErrorMessage)
            setLoader(false); // Reset loader if validation fails
        }
    }



    /////////////// ADD ARTIST ////////////////

    const [name, setName] = useState('')
    const [website, setWebsite] = useState('')
    const [facebook, setFacebook] = useState('')
    const [twitter, setTwitter] = useState('')
    const [instagram, setInstagram] = useState('')
    const [youtube, setYoutube] = useState('')
    const [spotify, setSpotify] = useState('')
    const [apple, setApple] = useState('')
    const [deezer, setDeezer] = useState('')
    const [soundCloud, setSoundCloud] = useState('')

    const clearArtistForm = () => {
        setName('');
        setWebsite('');
        setFacebook('');
        setTwitter('');
        setInstagram('');
        setYoutube('');
        setSpotify('');
        setApple('');
        setDeezer('');
        setSoundCloud('');
    }

    const handleAddArtist = () => {

        const artist = {
            name,
            website,
            facebook,
            twitter,
            instagram,
            youtube,
            spotify,
            apple,
            deezer,
            soundCloud
        }
        

        const newArtists = [...artists, artist]
        setArtists(newArtists)
       
        clearArtistForm()
    }


    const fileInputRef = useRef(null);
    const [imgPreview, setImgPreview] = useState(false)
    const [imgSrc, setImgSrc] = useState('')
    const [uploadLabel, setUploadLabel] = useState('Choose file')

    const uploadArtwork = async (event) => {
        setUploadLabel('Please Wait...')
        const file = event.target.files[0];
        const storageRef = sRef(storage, `releases/${file.name}`);
      
        try {
          // Upload file to Firebase Storage
          await uploadBytes(storageRef, file);
      
          // Get download URL
          const downloadURL = await getDownloadURL(storageRef);
          setImgSrc(downloadURL)
          setImgPreview(true)
          setUploadLabel('Replace file')
        } catch (error) {
          console.error("Error uploading file:", error);
        }
    }      

    const removeImg = () => {
        fileInputRef.current.value = '';
        setImgSrc('')
        setImgPreview(false)
        setUploadLabel('Choose file')
    }


  return (
    <div className='dash-section'>
        <h1 className='dash-title'>Edit Release</h1>
        <div className="row">
            <div className="col-12 mt-4">
                <div className="dash-card">
                    <h2 className="dash-card-title">
                        <Link to={'/admin/releases'} className='title-back-link'>
                            <i className="fi fi-rr-arrow-small-left"></i>
                        </Link>
                        {title}
                    </h2>
                    <div className="dash-tabs">
                        <Link 
                            to={'#'} 
                            className={`dash-tab ${tab === 1 && 'active'}`}
                            onClick={() => setTab(1)}
                        >Release Info</Link>
                        <Link 
                            to={'#'} 
                            className={`dash-tab ${tab === 2 && 'active'}`}
                            onClick={() => setTab(2)}
                        >Track Info</Link>
                        {/* <Link 
                            to={'#'} 
                            className={`dash-tab ${tab === 3 && 'active'}`}
                            onClick={() => setTab(3)}
                        >Credits</Link> */}
                        <Link 
                            to={'#'} 
                            className={`dash-tab ${tab === 4 && 'active'}`}
                            onClick={() => setTab(4)}
                        >Distribution</Link>
                    </div>
                    {
                        tab === 1 && (
                            <div className="row">
                                <div className="col-12 mt-3">
                                    <div className="dash-form-group">
                                        <label>Title</label>
                                        <input type="text" placeholder='Release Title' value={title} onChange={(e) => setTitle(e.target.value)} className='dash-form-input' />
                                    </div>
                                </div>
                                <div className="col-md-5 mt-3">
                                    <div className="dash-form-group">
                                        <label>Artist Role</label>
                                        <select value={artistRole} onChange={(e) => setArtistRole(e.target.value)} className='dash-form-select'>
                                            <option>Featuring</option>
                                            <option>Primary Artist</option>
                                            <option>Producer</option>
                                            <option>Arranger</option>
                                            <option>Composer</option>
                                            <option>Composer & Lyricist</option>
                                            <option>Lyricist</option>
                                            <option>Engineer</option>
                                            <option>Mixer</option>
                                            <option>Vocal Producer</option>
                                            <option>Chorus</option>
                                            <option>Remixer</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-5 mt-3">
                                    <div className="dash-form-group">
                                        <label>Artist Name</label>
                                        <div className="dropdown dash-form-dropdown">
                                            <button className="dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                {artistName.name}
                                            </button>
                                            <ul className="dropdown-menu">
                                                <li data-bs-toggle="modal" data-bs-target="#artist1Modal">
                                                    <i className="fi fi-rr-plus"></i>
                                                    Create Artist
                                                </li>
                                                {
                                                    artists.map((artist, i) => (
                                                        <li onClick={() => setArtistName({name: artist.name, id: artist.id})}>
                                                            {artist.name}
                                                        </li>
                                                    ))
                                                }
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-2 mt-4">
                                    <div className="dash-form-group">
                                        <div style={{ marginBottom: '20px' }}></div>
                                        <button className={`n-rounded-btn ${artistName.name === 'Name' && 'disabled'}`} onClick={() => setArtists1([...artists1, {name: artistName.name, role: artistRole,artistId: artistName.id}])}>
                                            <i className="fi fi-rr-plus"></i>
                                            Add
                                        </button>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="selected-artists">
                                        {
                                            artists1.map((artist, i) => (
                                                <div className='selected-artist'>
                                                    <div className="selected-artist-left">
                                                        <h6>{artist.name}</h6>
                                                        <span>{artist.role}</span>
                                                    </div>
                                                    <i className="fi fi-sr-cross" onClick={() => removeArtist1(i)}></i>
                                                </div>
                                            ))
                                        }
                                    </div>
                                </div>
                                <div className="col-md-6 mt-3">
                                    <div className="dash-form-group">
                                        <label>Album Artwork</label>
                                        <div className="img-file-upload">
                                            {
                                                imgPreview && (
                                                    <div className='img-preview'>
                                                        <img src={imgSrc} alt="" />
                                                        <i className="fi fi-rr-trash remove-artwork" onClick={removeImg}></i>
                                                    </div>
                                                )
                                            }
                                            <div className="dash-form-file py-4">
                                                <i className="fi fi-rr-cloud-upload"></i>
                                                {uploadLabel}
                                                <input type="file" ref={fileInputRef} onChange={uploadArtwork} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 mt-3">
                                    <div className="dash-form-group">
                                        <label>UPC</label>
                                        <input type="text" placeholder='UPC' value={upc} onChange={(e) => setUpc(e.target.value)} className={`dash-form-input`} />
                                    </div>
                                </div>
                                <div className="col-md-4 mt-3">
                                    <div className="dash-form-group">
                                        <label>Primary Genre</label>
                                        <div className="dropdown dash-form-dropdown">
                                            <input 
                                                type="text" 
                                                className='dash-form-input' 
                                                placeholder='Select genre' 
                                                data-bs-toggle="dropdown" 
                                                aria-expanded="false"
                                                value={primaryGenre}
                                                onChange={filterPrimaryGenres}
                                            />
                                            <ul className="dropdown-menu">
                                                {
                                                    primaryGenresList.map((item, i) => (
                                                        <li key={i} onClick={() => setPrimaryGenre(item)}>
                                                            {item}
                                                        </li>
                                                    ))
                                                }
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4 mt-3">
                                    <div className="dash-form-group">
                                        <label>Secondary Genre</label>
                                        <div className="dropdown dash-form-dropdown">
                                            <input 
                                                type="text" 
                                                className='dash-form-input' 
                                                placeholder='Select genre' 
                                                data-bs-toggle="dropdown" 
                                                aria-expanded="false"
                                                value={secondaryGenre}
                                                onChange={filterSecondaryGenres}
                                            />
                                            <ul className="dropdown-menu">
                                                {
                                                    secondaryGenresList.map((item, i) => (
                                                        <li key={i} onClick={() => setSecondaryGenre(item)}>
                                                            {item}
                                                        </li>
                                                    ))
                                                }
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4 mt-3">
                                    <div className="dash-form-group">
                                        <label>Label</label>
                                        <div className="dropdown dash-form-dropdown">
                                            <input 
                                                type="text" 
                                                className='dash-form-input' 
                                                placeholder='Select label' 
                                                data-bs-toggle="dropdown" 
                                                aria-expanded="false"
                                                value={label}
                                                onChange={filterLabels}
                                            />
                                            <ul className="dropdown-menu">
                                                {
                                                    labelsList.map((item, i) => (
                                                        <li key={item.id} onClick={() => setLabel(item.name)}>
                                                            {item.name}
                                                        </li>
                                                    ))
                                                }
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 mt-3">
                                    <div className="dash-form-group">
                                        <label>Original Release Date</label>
                                        <DatePicker
                                            id="date-picker"
                                            selected={originalDate}
                                            onChange={e => setOriginalDate(e)}
                                            dateFormat="yyyy/MM/dd"
                                            locale={enGB} 
                                            className='dash-form-input'
                                        />
                                        {/* <input type="date" value={originalDate} onChange={(e) => setOriginalDate(e.target.value)} className='dash-form-input' /> */}
                                    </div>
                                </div>
                                <div className="col-md-6 mt-3">
                                    <div className="dash-form-group">
                                        <label>Digital Release Date</label>
                                        <DatePicker
                                            id="date-picker"
                                            selected={digitalDate}
                                            onChange={e => setDigitalDate(e)}
                                            dateFormat="yyyy/MM/dd"
                                            locale={enGB} 
                                            className='dash-form-input'
                                        />
                                        {/* <input type="date" value={digitalDate} onChange={(e) => setDigitalDate(e.target.value)} className='dash-form-input' /> */}
                                    </div>
                                </div>
                                <div className="col-12 mt-3">
                                    <div className="dash-form-group">
                                        <label>Copyright</label>
                                        <div className="d-flex">
                                            <select value={copyrightYear} onChange={(e) => setCopyrightYear(e.target.value)} className='dash-form-select dash-copy-year'>
                                                {
                                                    years.map(year => (<option key={year}>{year}</option>))
                                                }
                                            </select>
                                            <input type="text" value={copyrightLine} onChange={(e) => setCopyrightLine(e.target.value)} placeholder='Copyright Line' className='dash-form-input dash-copy-line' />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 mt-3">
                                    <div className="dash-form-group">
                                        <label>Publishing</label>
                                        <div className="d-flex">
                                            <select value={publishingYear} onChange={(e) => setPublishingYear(e.target.value)} className='dash-form-select dash-copy-year'>
                                                {
                                                    years.map(year => (<option key={year}>{year}</option>))
                                                }
                                            </select>
                                            <input type="text" value={publishingLine} onChange={(e) => setPublishingLine(e.target.value)} placeholder='Publishing Line' className='dash-form-input dash-copy-line' />
                                        </div>
                                    </div>
                                </div>
                                {/* <div className="col-md-6 mt-3">
                                    <div className="dash-form-group">
                                        <label>Status</label>
                                        <div className="dropdown dash-form-dropdown">
                                            <button className="dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                {status}
                                            </button>
                                            <ul className="dropdown-menu">
                                                <li onClick={() => setStatus('Distributed')}>
                                                    Live
                                                </li>
                                                <li onClick={() => setStatus('Processing')}>
                                                    Processing
                                                </li>
                                                <li onClick={() => setStatus('Takedown')}>
                                                    Takedown
                                                </li>
                                                <li onClick={() => setStatus('Error')}>
                                                    Error
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div> */}
                                {/* <div className="col-md-6 mt-3">
                                    {
                                        status === 'Error' && (
                                            <div className="dash-form-group">
                                                <label>Notes</label>
                                                <input type="text" placeholder='Notes' value={statusNotes} onChange={(e) => setStatusNotes(e.target.value)} className='dash-form-input' />
                                            </div>
                                        )
                                    }
                                </div> */}
                                <div className="col-md-6 mt-3">
                                    <div className="dash-form-group">
                                        <label>Territories</label>
                                        <div className="form-check dash-form-check">
                                            <input className="form-check-input" checked={activeRadio === 1 ? true : false} onChange={() => {setActiveRadio(1); setCheckedCountries(['Worldwide'])}} type="radio" name="territory" id="territory1" />
                                            <label className="form-check-label" for="territory1">
                                                Worldwide
                                            </label>
                                        </div>
                                        <div className="form-check dash-form-check">
                                            <input className="form-check-input" checked={activeRadio === 2 ? true : false} onChange={() => {setActiveRadio(2); setCheckedCountries([])}} type="radio" name="territory" id="territory2" />
                                            <label className="form-check-label" for="territory2">
                                                Select countries
                                            </label>
                                        </div>
                                    </div>
                                    {
                                        activeRadio === 2 && (
                                            <div className="dash-form-group mt-3">
                                                <div className="dropdown dash-form-dropdown">
                                                    <button className="dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                        Countries
                                                    </button>
                                                    <ul className="dropdown-menu">
                                                        {
                                                            countries.map((country, i) => (
                                                                <li className='form-check' key={i}>
                                                                    <input 
                                                                        className="form-check-input" 
                                                                        onChange={(e) => handleCheckCountry(country, e)} 
                                                                        checked={checkedCountries.includes(country)}
                                                                        type="checkbox" 
                                                                    />
                                                                    {country}
                                                                </li>
                                                            ))
                                                        }
                                                    </ul>
                                                </div>
                                            </div>
                                        )
                                    }
                                </div>
                                <div className="col-12 mt-3">
                                    <div className="dash-form-btns">
                                        <button className='dash-form-btn' onClick={() => setTab(2)}>Next</button>
                                    </div>
                                </div>
                            </div>
                        )
                    }
                    {
                        tab === 2 && (
                            <div className="row">
                                <div className="col-md-6 mt-3">
                                    <div className="dash-form-group">
                                        <label>Add Track</label>
                                        <div className="dash-form-file py-4">
                                            <i className="fi fi-rr-cloud-upload"></i>
                                            Choose file
                                            <input type="file" onChange={readFile} multiple />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 mt-3">
                                    <DragDropContext onDragEnd={onDragEnd}>
                                        <Droppable droppableId="droppable">
                                            {(provided) => (
                                            <div className="added-tracks" {...provided.droppableProps} ref={provided.innerRef}>
                                                {tracks.map((track, i) => (
                                                    <Draggable key={track.id} draggableId={track.id} index={i}>
                                                        {(provided) => (
                                                        <div
                                                            className="added-track"
                                                            ref={provided.innerRef}
                                                            {...provided.draggableProps}
                                                            {...provided.dragHandleProps}
                                                        >
                                                            <div className="added-track-right">
                                                                <i className="fi fi-sr-grip-dots drag-track-btn"></i>
                                                                {i + 1 < 10 ? `0${i + 1}` : i + 1}. {track.title}
                                                            </div>
                                                            <div className="added-track-left">
                                                                <i 
                                                                    className="fi fi-rr-pencil" 
                                                                    data-bs-toggle="modal" 
                                                                    data-bs-target="#editTrackModal"
                                                                    onClick={() => {
                                                                        setEditTitle(track.title)
                                                                        setEditId(track.id)
                                                                        setArtists2(track.artists || [])
                                                                        setGenre(track.genre)
                                                                        setIsrc(track.isrc)
                                                                        setCopyright(track.copyright)
                                                                        setTrackLanguage(track.trackLanguage)
                                                                        setClipStart(track.clipStart)
                                                                        setExplicit(track.explicit)
                                                                        setLyrics(track.lyrics || '')
                                                                        track.trackLanguage !== 'Instrumental' ? setActiveRadio1(2) : setActiveRadio1(1)
                                                                    }}
                                                                ></i>
                                                                <i 
                                                                    className="fi fi-sr-cross"
                                                                    onClick={() => removeTrack(i)}
                                                                ></i>
                                                            </div>
                                                        </div>
                                                        )}
                                                    </Draggable>
                                                ))}
                                                {provided.placeholder}
                                            </div>
                                            )}
                                        </Droppable>
                                    </DragDropContext>
                                </div>
                                <div className="col-12 mt-4">
                                    <div className="dash-form-btns">
                                        <button className='dash-form-btn' onClick={() => setTab(4)}>Next</button>
                                    </div>
                                </div>
                            </div>
                        )
                    }
                    {/* {
                        tab === 3 && (
                            <div className="row">
                                <div className="col-md-6 mt-3">
                                    <div className="dash-form-group">
                                        <label>Role</label>
                                        <select value={role} onChange={(e) => setRole(e.target.value)} className='dash-form-select'>
                                            <option>Arranger</option>
                                            <option>Composer</option>
                                            <option>Lyricist</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-6 mt-3">
                                    <div className="dash-form-group">
                                        <label>Writer Name</label>
                                        <input 
                                            type="text" 
                                            placeholder='Writer Name' 
                                            className='dash-form-input' 
                                            value={writerName}
                                            onChange={(e) => setWriterName(e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6 mt-3">
                                    <div className="dash-form-group">
                                        <label>Share (%)</label>
                                        <input 
                                            type="number" 
                                            placeholder='Share (%)' 
                                            className='dash-form-input' 
                                            value={share}
                                            onChange={(e) => setShare(e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div className="col-12 mt-3">
                                    <div className="dash-form-btns">
                                        <button className='dash-form-btn' onClick={() => setTab(4)}>Next</button>
                                    </div>
                                </div>
                            </div>
                        )
                    } */}
                    {
                        tab === 4 && (
                            <div className="row">
                                <div className="d-flex justify-content-end">
                                    <button 
                                        className={`dash-card-heading-btn ${selectedPlatforms.length === 0 && 'disabled'}`}
                                        data-bs-toggle="modal"
                                        data-bs-target="#updateAllModal"
                                        disabled={selectedPlatforms.length === 0}
                                    >
                                        Update Statuses
                                    </button>
                                </div>
                                <div className="table-responsive">
                                    <table className="table dash-table">
                                        <thead>
                                            <tr>
                                                <td>
                                                    <div className="d-flex align-items-center">
                                                        <div className='dash-form-check me-3'>
                                                            <input 
                                                                type="checkbox" 
                                                                className='form-check-input' 
                                                                onChange={checkAll}
                                                            />
                                                        </div>
                                                        Platform
                                                    </div>
                                                </td>
                                                <td>Status</td>
                                                <td>Link</td>
                                                <td>Action</td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                platforms.map((platform, i) => (
                                                    <tr key={i}>
                                                        <td>
                                                            <div className="table-item d-flex align-items-center">
                                                                <div className='dash-form-check me-2'>
                                                                    <input 
                                                                        type="checkbox" 
                                                                        className='form-check-input' 
                                                                        checked={platform.selected}
                                                                        onChange={() => handleCheck(i)}
                                                                    />
                                                                </div>
                                                                <img className='platform-img' src={platform.logo} alt="" />
                                                                <h6 className='ms-2'>{platform.title}</h6>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className={`release-status ${statusClasses[platform.status]}`}>{platform.status}</div>
                                                        </td>
                                                        <td>
                                                            <div className='table-item'>
                                                                { platform.link === '' && '-' }
                                                                {
                                                                    platform.link !== '' && (
                                                                        <a href={platform.link} target='blank'><i className="fi fi-rr-arrow-up-right-from-square"></i></a>
                                                                    )
                                                                }
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="table-item d-flex flex-wrap">
                                                                {
                                                                    platform.status !== 'Taken Down' && (
                                                                        <button 
                                                                            className="table-btn a-red me-2"
                                                                            onClick={() => takeDown(i)}
                                                                        >Take Down</button>
                                                                    )
                                                                }
                                                                {
                                                                    platform.status !== 'Distributed' && (
                                                                        <button 
                                                                            className="table-btn a-green me-2"
                                                                            onClick={() => distribute(i)}
                                                                        >Distribute</button>
                                                                    )
                                                                }
                                                                <i 
                                                                    className="fi fi-rr-link table-action-btn a-blue"
                                                                    data-bs-toggle="modal"
                                                                    data-bs-target="#updateStatusModal"
                                                                    style={{ height: '35px', width: '35px' }}
                                                                    onClick={() => {
                                                                        setPlatformIndex(i)
                                                                        setPlatformLink(platform.link)
                                                                    }}
                                                                ></i>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                {
                                    error !== '' && (
                                        <div className="col-12 mt-3">
                                            <h6 className='text-danger text-center'>{error}</h6>
                                        </div>
                                    )
                                }
                                <div className="col-12 mt-3">
                                    <div className="dash-form-btns">
                                        <button 
                                            className={`dash-form-btn ${loader ? 'disabled' : ''}`} 
                                            onClick={handleAddRelease}
                                            disabled={loader}
                                        >
                                            {loader ? 'Submitting...' : 'Submit'}
                                        </button>
                                        <button ref={successBtn} data-bs-toggle="modal" data-bs-target="#successModal" hidden></button>
                                    </div>
                                </div>
                            </div>
                        )
                    }
                </div>
            </div>
        </div>


        {/* ARTIST MODAL */}
        <div className="modal fade" id="artist1Modal" tabindex="-1" aria-labelledby="artist1ModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-lg modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h1 className="modal-title fs-5" id="artist1ModalLabel">Add Artist</h1>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <div className="row">
                            <div className="col-12">
                                <h4 className='dash-form-heading'>General Information</h4>
                            </div>
                            <div className="col-md-6 mt-3">
                                <div className="dash-form-group">
                                    <label>Name</label>
                                    <input value={name} onChange={(e) => setName(e.target.value)} type="text" placeholder='Name' className='dash-form-input' />
                                </div>
                            </div>
                            <div className="col-md-6 mt-3">
                                <div className="dash-form-group">
                                    <label>Website</label>
                                    <input value={website} onChange={(e) => setWebsite(e.target.value)} type="text" placeholder='Website' className='dash-form-input' />
                                </div>
                            </div>
                            <div className="col-12 mt-4">
                                <h4 className='dash-form-heading'>Profile Information</h4>
                            </div>
                            <div className="col-md-6 mt-3">
                                <div className="dash-form-group">
                                    <label>Spotify</label>
                                    <input value={spotify} onChange={(e) => setSpotify(e.target.value)} type="text" placeholder='Spotify' className='dash-form-input' />
                                </div>
                            </div>
                            <div className="col-md-6 mt-3">
                                <div className="dash-form-group">
                                    <label>Apple Music</label>
                                    <input value={apple} onChange={(e) => setApple(e.target.value)} type="text" placeholder='Apple' className='dash-form-input' />
                                </div>
                            </div>
                            <div className="col-md-6 mt-3">
                                <div className="dash-form-group">
                                    <label>Facebook</label>
                                    <input value={facebook} onChange={(e) => setFacebook(e.target.value)} type="text" placeholder='Facebook' className='dash-form-input' />
                                </div>
                            </div>
                            <div className="col-md-6 mt-3">
                                <div className="dash-form-group">
                                    <label>Instagram</label>
                                    <input value={instagram} onChange={(e) => setInstagram(e.target.value)} type="text" placeholder='Instagram' className='dash-form-input' />
                                </div>
                            </div>
                            <div className="col-md-6 mt-3">
                                <div className="dash-form-group">
                                    <label>Youtube</label>
                                    <input value={youtube} onChange={(e) => setYoutube(e.target.value)} type="text" placeholder='Youtube' className='dash-form-input' />
                                </div>
                            </div>
                            <div className="col-md-6 mt-3">
                                <div className="dash-form-group">
                                    <label>X</label>
                                    <input value={twitter} onChange={(e) => setTwitter(e.target.value)} type="text" placeholder='Twitter' className='dash-form-input' />
                                </div>
                            </div>
                            <div className="col-md-6 mt-3">
                                <div className="dash-form-group">
                                    <label>Deezer</label>
                                    <input value={deezer} onChange={(e) => setDeezer(e.target.value)} type="text" placeholder='Deezer' className='dash-form-input' />
                                </div>
                            </div>
                            <div className="col-md-6 mt-3">
                                <div className="dash-form-group">
                                    <label>SoundCloud</label>
                                    <input value={soundCloud} onChange={(e) => setSoundCloud(e.target.value)} type="text" placeholder='SoundCloud' className='dash-form-input' />
                                </div>
                            </div>
                            <div className="col-12 mt-3">
                                <div className="dash-form-btns">
                                    <button 
                                        className='dash-form-btn' 
                                        data-bs-dismiss="modal"
                                        onClick={() => {
                                            handleAddArtist()
                                            setArtistName(name)
                                        }}
                                    >Submit</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="modal fade" id="artist2Modal" tabindex="-1" aria-labelledby="artist2ModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-lg modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h1 className="modal-title fs-5" id="artist2ModalLabel">Add Artist</h1>
                        <button type="button" className="btn-close" data-bs-toggle="modal" data-bs-target="#editTrackModal"></button>
                    </div>
                    <div className="modal-body">
                        <div className="row">
                            <div className="col-12">
                                <h4 className='dash-form-heading'>General Information</h4>
                            </div>
                            <div className="col-md-6 mt-3">
                                <div className="dash-form-group">
                                    <label>Name</label>
                                    <input value={name} onChange={(e) => setName(e.target.value)} type="text" placeholder='Name' className='dash-form-input' />
                                </div>
                            </div>
                            <div className="col-md-6 mt-3">
                                <div className="dash-form-group">
                                    <label>Website</label>
                                    <input value={website} onChange={(e) => setWebsite(e.target.value)} type="text" placeholder='Website' className='dash-form-input' />
                                </div>
                            </div>
                            <div className="col-12 mt-4">
                                <h4 className='dash-form-heading'>Profile Information</h4>
                            </div>
                            <div className="col-md-6 mt-3">
                                <div className="dash-form-group">
                                    <label>Spotify</label>
                                    <input value={spotify} onChange={(e) => setSpotify(e.target.value)} type="text" placeholder='Spotify' className='dash-form-input' />
                                </div>
                            </div>
                            <div className="col-md-6 mt-3">
                                <div className="dash-form-group">
                                    <label>Apple Music</label>
                                    <input value={apple} onChange={(e) => setApple(e.target.value)} type="text" placeholder='Apple' className='dash-form-input' />
                                </div>
                            </div>
                            <div className="col-md-6 mt-3">
                                <div className="dash-form-group">
                                    <label>Youtube</label>
                                    <input value={youtube} onChange={(e) => setYoutube(e.target.value)} type="text" placeholder='Youtube' className='dash-form-input' />
                                </div>
                            </div>
                            <div className="col-md-6 mt-3">
                                <div className="dash-form-group">
                                    <label>Facebook</label>
                                    <input value={facebook} onChange={(e) => setFacebook(e.target.value)} type="text" placeholder='Facebook' className='dash-form-input' />
                                </div>
                            </div>
                            <div className="col-md-6 mt-3">
                                <div className="dash-form-group">
                                    <label>Instagram</label>
                                    <input value={instagram} onChange={(e) => setInstagram(e.target.value)} type="text" placeholder='Instagram' className='dash-form-input' />
                                </div>
                            </div>
                            <div className="col-md-6 mt-3">
                                <div className="dash-form-group">
                                    <label>X</label>
                                    <input value={twitter} onChange={(e) => setTwitter(e.target.value)} type="text" placeholder='Twitter' className='dash-form-input' />
                                </div>
                            </div>
                            <div className="col-md-6 mt-3">
                                <div className="dash-form-group">
                                    <label>Deezer</label>
                                    <input value={deezer} onChange={(e) => setDeezer(e.target.value)} type="text" placeholder='Deezer' className='dash-form-input' />
                                </div>
                            </div>
                            <div className="col-md-6 mt-3">
                                <div className="dash-form-group">
                                    <label>SoundCloud</label>
                                    <input value={soundCloud} onChange={(e) => setSoundCloud(e.target.value)} type="text" placeholder='SoundCloud' className='dash-form-input' />
                                </div>
                            </div>
                            <div className="col-12 mt-3">
                                <div className="dash-form-btns">
                                    <button 
                                        className='dash-form-btn' 
                                        data-bs-toggle="modal"
                                        data-bs-target="#editTrackModal"
                                        onClick={() => {
                                            handleAddArtist()
                                            setArtists2([...artists2, {name: name, role: artistRole}])
                                        }}
                                    >Submit</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <div className="modal fade" id="editTrackModal" tabindex="-1" aria-labelledby="editTrackModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-lg modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h1 className="modal-title fs-5" id="editTrackModalLabel">Edit Track</h1>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <div className="row">
                            <div className="col-md-6 mt-3">
                                <div className="dash-form-group">
                                    <label>Title</label>
                                    <input type="text" value={editTitle} onChange={(e) => setEditTitle(e.target.value)} placeholder='Title' className='dash-form-input' />
                                </div>
                            </div>
                            <div className="col-md-6"></div>
                            <div className="col-md-6 mt-3">
                                <div className="dash-form-group">
                                    <label>Artist Role</label>
                                    <select value={artistRole} onChange={(e) => setArtistRole(e.target.value)} className='dash-form-select'>
                                        <option>Featuring</option>
                                        <option>Primary Artist</option>
                                        <option>Producer</option>
                                        <option>Arranger</option>
                                        <option>Composer</option>
                                        <option>Composer & Lyricist</option>
                                        <option>Lyricist</option>
                                        <option>Engineer</option>
                                        <option>Mixer</option>
                                        <option>Vocal Producer</option>
                                        <option>Chorus</option>
                                        <option>Remixer</option>
                                    </select>
                                </div>
                            </div>
                            <div className="col-md-6 mt-3">
                                <div className="dash-form-group">
                                    <label>Artist Name</label>
                                    <div className="dropdown dash-form-dropdown">
                                        <button className="dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                            Name
                                        </button>
                                        <ul className="dropdown-menu">
                                            <li data-bs-toggle="modal" data-bs-target="#artist2Modal">
                                                <i className="fi fi-rr-plus"></i>
                                                Create Artist
                                            </li>
                                            {
                                                artists.map((artist, i) => (
                                                    <li onClick={() => setArtists2([...artists2, {name: artist.name, role: artistRole, artistId: artist.id}])}>
                                                        {artist.name} 
                                                    </li>
                                                ))
                                            }
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="selected-artists">
                                    {
                                        artists2.map((artist, i) => (
                                            <div className='selected-artist'>
                                                <div className="selected-artist-left">
                                                    <h6>{artist.name}</h6>
                                                    <span>{artist.role}</span>
                                                </div>
                                                <i className="fi fi-sr-cross" onClick={() => removeArtist2(i)}></i>
                                            </div>
                                        ))
                                    }
                                </div>
                            </div>
                            <div className="col-md-6 mt-3">
                                <div className="dash-form-group">
                                    <label>Genre</label>
                                    <div className="dropdown dash-form-dropdown">
                                        <input 
                                            type="text" 
                                            className='dash-form-input' 
                                            placeholder='Select genre' 
                                            data-bs-toggle="dropdown" 
                                            aria-expanded="false"
                                            value={genre}
                                            onChange={filterGenres}
                                        />
                                        <ul className="dropdown-menu">
                                            {
                                                genresList.map((item, i) => (
                                                    <li key={i} onClick={() => setGenre(item)}>
                                                        {item}
                                                    </li>
                                                ))
                                            }
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 mt-3">
                                <div className="dash-form-group">
                                    <label>Preview/Clip Start Time</label>
                                    <input type="text" value={clipStart} onChange={(e) => setClipStart(e.target.value)} placeholder='mm:ss' className='dash-form-input' />
                                </div>
                            </div>
                            <div className="col-md-6 mt-3">
                                <div className="dash-form-group">
                                    <label>ISRC</label>
                                    <input 
                                        type="text" 
                                        placeholder='LL-LLL-NN-NNNNN' 
                                        className={`dash-form-input ${isrcDisabled && 'disabled'}`} 
                                        disabled={isrcDisabled} 
                                        value={isrc}
                                        onChange={(e) => setIsrc(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="col-md-6 mt-3">
                                <div className="dash-form-group">
                                    <label>Copyright</label>
                                    <select value={copyright} onChange={(e) => setCopyright(e.target.value)} className='dash-form-select'>
                                        <option>Original Song</option>
                                        <option>Public Domain</option>
                                    </select>
                                </div>
                            </div>
                            <div className="col-md-6 mt-3">
                                <div className="dash-form-group">
                                    <label>Language of Lyrics</label>
                                    <div className="form-check dash-form-check">
                                        <input 
                                            className="form-check-input" 
                                            checked={activeRadio1 === 1 ? true : false} 
                                            onChange={() => {setActiveRadio1(1); setTrackLanguage('Instrumental')}} 
                                            type="radio" 
                                            name="trackRadios" 
                                            id="tr1" 
                                        />
                                        <label className="form-check-label" for="tr1">
                                            Instrumental
                                        </label>
                                    </div>
                                    <div className="form-check dash-form-check">
                                        <input 
                                            className="form-check-input" 
                                            checked={activeRadio1 === 2 ? true : false} 
                                            onChange={() => {setActiveRadio1(2); setTrackLanguage(languages[0])}} 
                                            type="radio" 
                                            name="trackRadios" 
                                            id="tr2" 
                                        />
                                        <label className="form-check-label" for="tr2">
                                            Select Language
                                        </label>
                                    </div>
                                </div>
                                {
                                    activeRadio1 === 2 && (
                                        <div className="dash-form-group mt-3">
                                            <select value={trackLanguage} onChange={(e) => setTrackLanguage(e.target.value)} className='dash-form-select'>
                                                <option>{languages[0]}</option>
                                                {
                                                    languages.map((language, i) => (
                                                        <option key={i}>{language}</option>
                                                    ))
                                                }
                                            </select>
                                        </div>
                                    )
                                }
                            </div>
                            <div className="col-md-6 mt-3">
                                <div className="dash-form-group">
                                    <label>Explicit</label>
                                    <div className="form-check dash-form-check">
                                        <input 
                                            className="form-check-input" 
                                            type="radio" 
                                            name="editEx" 
                                            id="editEx1"
                                            checked={explicit === 'Yes'}
                                            onChange={() => setExplicit('Yes')} 
                                        />
                                        <label className="form-check-label" for="editEx1">
                                            Yes
                                        </label>
                                    </div>
                                    <div className="form-check dash-form-check">
                                        <input 
                                            className="form-check-input" 
                                            type="radio" 
                                            name="editEx"
                                            id="editEx2" 
                                            checked={explicit === 'No'}
                                            onChange={() => setExplicit('No')}
                                        />
                                        <label className="form-check-label" for="editEx2">
                                            No
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 mt-3">
                                <div className="dash-form-group">
                                    <label>Lyrics</label>
                                    <textarea value={lyrics} onChange={e => setLyrics(e.target.value)} className='dash-form-textarea'></textarea>
                                </div>
                            </div>
                            <div className="col-12 mt-3">
                                <div className="dash-form-btns">
                                    <button 
                                        className='dash-form-btn' 
                                        data-bs-dismiss="modal"
                                        onClick={updateTrack}
                                    >Update</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div className="modal fade" id="updateStatusModal" tabindex="-1" aria-labelledby="updateStatusModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h1 className="modal-title fs-5" id="updateStatusModalLabel">Edit Link</h1>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <div className="row">
                            <div className="col-12 mt-3">
                                <div className="dash-form-group">
                                    <label>Link</label>
                                    <input type="text" value={platformLink} onChange={e => setPlatformLink(e.target.value)} placeholder='Link' className='dash-form-input' />
                                </div>
                            </div>
                            <div className="col-12 mt-3">
                                <div className="dash-form-btns">
                                    <button 
                                        className='dash-form-btn' 
                                        data-bs-dismiss="modal"
                                        onClick={updateStatus}
                                    >Submit</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div className="modal fade" id="errorNotesModal" tabindex="-1" aria-labelledby="errorNotesModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h1 className="modal-title fs-5" id="errorNotesModalLabel">Add Notes</h1>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <div className="row">
                            <div className="col-12 mt-3">
                                <div className="dash-form-group">
                                    <label>Notes</label>
                                    <input type="text" placeholder='Notes' value={statusNotes} onChange={(e) => setStatusNotes(e.target.value)} className='dash-form-input' />
                                </div>
                            </div>
                            <div className="col-12 mt-3">
                                <div className="dash-form-btns">
                                    <button 
                                        className='dash-form-btn' 
                                        data-bs-dismiss="modal"
                                        onClick={updateAllStatus}
                                    >Submit</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div className="modal fade" id="updateAllModal" tabindex="-1" aria-labelledby="updateAllModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h1 className="modal-title fs-5" id="updateAllModalLabel">Update Status</h1>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <div className="row">
                            <div className="col-12 mt-3">
                                <div className="dash-form-group">
                                    <label>Status</label>
                                    <div className="dropdown dash-form-dropdown">
                                        <button className="dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                            {statusAll}
                                        </button>
                                        <ul className="dropdown-menu">
                                            <li onClick={() => setStatusAll('Taken Down')}>Taken Down</li>
                                            <li onClick={() => setStatusAll('Distributed')}>Distributed</li>
                                            <li onClick={() => setStatusAll('Error')}>Error</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 mt-3">
                                <div className="dash-form-btns">
                                    {
                                        statusAll === 'Error' ? (
                                            <button 
                                                className='dash-form-btn' 
                                                data-bs-toggle="modal"
                                                data-bs-target="#errorNotesModal"
                                            >Submit</button>
                                        ) : (
                                            <button 
                                                className='dash-form-btn' 
                                                data-bs-dismiss="modal"
                                                onClick={updateAllStatus}
                                            >Submit</button>
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div className="modal fade" id="successModal" tabindex="-1" data-bs-backdrop="static" aria-labelledby="successModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-body success-modal">
                        <a className='success-close-btn' href="/admin/releases">
                            <i className="fi fi-rr-cross"></i>
                        </a>
                        <i className="fi fi-rr-check-circle text-success success-icon"></i>
                        <h5>Release Updated Successfully!</h5>
                    </div>
                </div>
            </div>
        </div>

        <div className={`loader-container ${loader && 'active'}`}>
            <div className="loader"></div>
        </div>
    </div>
  )
}

export default AdminEditRelease